import React from 'react';
import styles from './ClientInfoTitle.module.css';

interface ClientInfoTitleProps {
  name: string;
  surname: string;
  middlename: string;
}

const ClientInfoTitle: React.FC<ClientInfoTitleProps> = ({ name, surname, middlename }) => {
  return (
    <div className={`${styles.clientInfoTitle} name name-green`}>
      {surname} {name} {middlename}
    </div>
  );
};

export default ClientInfoTitle;
